const LAYOUTS = {
  DASHBOARD: '/dashboard',
  PROGRAMS: '/programs',
  VPP: '/vpp',
  REPORTS: '/reports',
  ADMIN: '/admin',
}

const MICROSERVICES = {
  PROGRAMMANAGER: 'programs-mgr',
  SITEMANAGER: 'site-mgr',
  DISPATCHMANAGER: 'dispatch-mgr',
  ENROLLMENTMANAGER: 'enrollment-mgr',
  SESSIONMANAGER: 'session-mgr',
  VPPMANAGER: 'vpp-mgr',
   HECOSDPMANAGER: 'hecosdp-mgr'
}

const COMMON = {
  CLICKAWAY: 'clickaway',
}

const SORTORDER = {
  ASC: 'asc',
  DESC: 'desc',
}

export { LAYOUTS, MICROSERVICES, COMMON, SORTORDER }
